import CharacterCount from "@tiptap/extension-character-count";
import Emoji, { gitHubEmojis } from "@tiptap/extension-emoji";
import Highlight from "@tiptap/extension-highlight";
import Placeholder from "@tiptap/extension-placeholder";
import { FontSize, TextStyle } from "@tiptap/extension-text-style";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { useCallback } from "react";

interface IConfig {
  editorProps?: {
    className?: string;
  };
  placeholder?: {
    text: string;
  };
  characterCount?: {
    limit: number;
  };
}

export const useInputEditor = ({
  editorProps,
  placeholder,
  characterCount,
}: IConfig = {}) => {
  const editor = useEditor({
    extensions: [
      Highlight.configure({
        HTMLAttributes: {
          class: "highlight bg-warning_light text-warning_main",
        },
      }),
      Placeholder.configure({
        placeholder: placeholder?.text || "メッセージを入力してください。",
      }),
      Emoji.configure({
        emojis: gitHubEmojis,
        enableEmoticons: true,
        HTMLAttributes: {
          class: "emoji",
        },
      }),
      StarterKit.configure({
        bulletList: {
          keepMarks: true,
          keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
        },
        orderedList: {
          keepMarks: true,
          keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
        },
        hardBreak: false, // We will use our custom hard break extension
      }),
      CharacterCount.configure({
        limit: characterCount?.limit || 2000, // Giữ markup, chỉ chặn nhập thêm ký tự
      }),
      FontSize,
      TextStyle,
    ],
    // autofocus: true,
    editorProps: {
      attributes: {
        class: editorProps?.className || "tiptapChat",
      },
    },
  });

  const setEditorContent = useCallback(
    (content: string) => {
      editor?.commands.setContent(content);

      // Move cursor to the end of the content
      editor.view.dom.focus();
      editor.commands.focus("end");
    },
    [editor]
  );

  return { editor, setEditorContent };
};
